var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.56 69.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-13{opacity:0;}.cls-13,.cls-2{fill:#fff;}.cls-3{opacity:0.09;}.cls-4{opacity:0.18;}.cls-5{opacity:0.27;}.cls-6{opacity:0.36;}.cls-7{opacity:0.45;}.cls-8{opacity:0.55;}.cls-9{opacity:0.64;}.cls-10{opacity:0.73;}.cls-11{opacity:0.82;}.cls-12{opacity:0.91;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.17,69.44C33.05,60,33,45.21,33,35.69l.09.16c-4.81-2.79-17.23-10-21.87-12.73L3.94,18.83,11.3,23c4.63,2.62,17.18,9.82,22,12.56l.09,0v.11c0,9.55,0,24.3-.19,33.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.94,18.83c7.65,4.87,16.3,10.43,23.66,15.64,1,.69,1.94,1.37,2.85,2.15a2.65,2.65,0,0,1,.4.42,8.55,8.55,0,0,1,.42,2.07c1.07,9.69,1.49,20.56,1.9,30.33-.68-8.69-1.37-21.77-2.37-30.27a9.93,9.93,0,0,0-.37-1.88,4.07,4.07,0,0,0-.68-.63c-7-5.29-18.5-12.77-25.81-17.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.94,18.83c4.24,3.05,8.4,6.19,12.52,9.38,2.07,1.59,4.1,3.23,6.11,4.89a42.15,42.15,0,0,1,5.8,5.37c1.08,2.45,1.33,5.1,1.85,7.69s.83,5.15,1.17,7.74c.69,5.17,1.3,10.35,1.78,15.54-.67-4.6-1.53-10.95-2.24-15.47-.41-2.57-.8-5.15-1.26-7.71a37,37,0,0,0-1.82-7.47,42.56,42.56,0,0,0-5.63-5.26c-2-1.68-4-3.3-6-5-3.54-2.87-8.62-6.87-12.23-9.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.94,18.83c5.79,4.92,11.47,10,16.85,15.35a44.07,44.07,0,0,1,5.1,5.73,26.94,26.94,0,0,1,1.75,4.49c1,3.34,1.86,6.73,2.61,10.14,1.1,4.94,2.09,9.91,2.92,14.91-1.86-8-3.6-16.05-5.92-23.93-.23-.81-.61-1.9-.87-2.69a21.47,21.47,0,0,0-1.12-2.54,44.84,44.84,0,0,0-4.94-5.64c-5.14-5.21-11-10.74-16.38-15.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.94,18.83c5.2,5.32,10.22,10.81,15,16.52A42.22,42.22,0,0,1,24.29,43c2.91,6.18,4.89,12.77,6.89,19.28.68,2.38,1.37,4.76,2,7.16-.8-2.34-1.57-4.7-2.38-7a195,195,0,0,0-7.25-19,43.4,43.4,0,0,0-5.24-7.53c-4.49-5.57-9.68-11.55-14.35-17Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.94,18.83c6,7.76,11.76,15.64,17,23.94A201.45,201.45,0,0,1,33.16,69.45c-3.8-7.76-8.76-18.83-13.08-26.17C14.92,35,9.27,27,3.94,18.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.94,18.83c3.52,6.08,7.34,13,10.82,19.07,6,10.47,12.65,20.93,18.4,31.56C27.8,61.49,22.51,53,17.49,44.77c-5-8.41-9.41-17.1-13.55-25.94Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.94,18.83c3.55,9.1,7.08,18.36,12,26.79a218,218,0,0,0,12.7,18c1.48,2,3,3.89,4.51,5.83a145.61,145.61,0,0,1-18.26-23.2c-5-8.56-8.29-17.95-11-27.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.94,18.83c2,9.76,4.49,19.57,9.52,28.22a80.66,80.66,0,0,0,9,11.87A131.32,131.32,0,0,0,33.15,69.47a79.63,79.63,0,0,1-19.3-19.33C7.67,41,4.93,29.68,3.94,18.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.94,18.83C4,31.59,6.85,44.91,15.44,54.69A65.05,65.05,0,0,0,26.67,65.2a67.09,67.09,0,0,0,6.48,4.27C22.74,64.82,13.56,56.82,8.29,46.62A52.33,52.33,0,0,1,3.94,18.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.94,18.83C2.13,29.28,3,40.67,8.49,49.91c.66,1,1.5,2.4,2.22,3.3l1.22,1.58c.35.47.93,1.06,1.31,1.51a46.11,46.11,0,0,0,5,4.85,48.77,48.77,0,0,0,14.88,8.32,39.84,39.84,0,0,1-14.84-6.71A39.65,39.65,0,0,1,5.22,47C1.37,38.23,1.2,28,3.94,18.83Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M3.94,18.83C.18,29.31.06,41.7,6,51.35A38,38,0,0,0,24.94,67.26a36.45,36.45,0,0,0,8.2,2.22,33.72,33.72,0,0,1-16.4-5A35,35,0,0,1,1.11,44.18,36.6,36.6,0,0,1,3.94,18.83Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "36.39 69.47 36.39 35.69 65.55 18.78"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.67,19c-8.43,5.6-17,11.09-25.1,17.09a15.78,15.78,0,0,0-1.34,1.11l-.13.15-.06.17a77.53,77.53,0,0,0-.88,7.75c-.64,8.08-1.11,16.17-1.55,24.26l-.44,0c.52-9.44,1-18.89,1.87-28.31a32.46,32.46,0,0,1,.53-3.8,1.4,1.4,0,0,1,.51-.71c.38-.35.79-.66,1.19-1,3.79-2.84,7.73-5.46,11.65-8.11q6.72-4.53,13.51-9l.24.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.7,19c-6.22,4.73-12.42,9.5-18.42,14.52a41.35,41.35,0,0,0-5.6,5.3c-1,2.28-1.29,5-1.79,7.48C38.57,54,37.58,61.74,36.64,69.5l-.5,0c.6-5.19,1.25-10.36,2-15.53.56-3.88,1.13-7.76,1.91-11.6a16.41,16.41,0,0,1,1.13-3.84A9.91,9.91,0,0,1,42.5,37c3.31-3.16,6.93-6,10.49-8.84q6.15-4.85,12.41-9.54l.3.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.73,19C59.65,24.51,53.54,30,47.86,36a33.63,33.63,0,0,0-3.59,4.31,19.78,19.78,0,0,0-1.41,3.43c-2.64,8.45-4.36,17.16-6.21,25.81l-.52-.11c.47-2.49,1-5,1.48-7.45,1.06-5,2.16-9.92,3.49-14.81a36.66,36.66,0,0,1,2.54-7.25,33.28,33.28,0,0,1,3.71-4.42c3.94-4.13,8.14-8,12.35-11.86q2.82-2.55,5.67-5.05l.36.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.75,19q-5,5.5-9.82,11.15c-1.6,1.89-3.19,3.78-4.74,5.7A43.78,43.78,0,0,0,46,43.37a184.68,184.68,0,0,0-7.08,19.11c-.77,2.35-1.53,4.71-2.26,7.07l-.52-.15c.68-2.39,1.39-4.76,2.12-7.13,1.48-4.74,3-9.46,4.79-14.1a50.62,50.62,0,0,1,3.07-6.84C50.22,35.07,55.34,29.62,60.29,24q2.51-2.74,5.06-5.45l.4.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.77,18.93c-5.54,8-11.27,16-16.34,24.32-3.65,6.33-6.64,13-9.74,19.67q-1.55,3.31-3.06,6.66l-.49-.21Q37.55,66,39,62.61a217.14,217.14,0,0,1,9.58-19.86c2.55-4.2,5.32-8.24,8.13-12.25s5.69-8,8.62-11.88l.44.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.77,18.89C61.5,27.5,56.81,36.41,52,44.73,47,52.92,41.78,61.52,36.6,69.61l-.43-.27c4.77-8.33,10-17,14.89-25.17,4.29-7.3,10.08-18,14.27-25.51l.44.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.76,18.84A132.45,132.45,0,0,1,54.59,46.21a146.23,146.23,0,0,1-18,23.41l-.33-.29c1.55-1.9,3.11-3.81,4.61-5.75C46.86,55.89,52.76,48,57,39.11c2.1-4.42,4-8.94,5.8-13.51.9-2.28,1.75-4.58,2.59-6.89l.42.13Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.73,18.8a75.92,75.92,0,0,1-6.79,25.51c-5,10.27-13.34,18.6-22.44,25.31l-.22-.29A114.06,114.06,0,0,0,47.07,58.92,75.1,75.1,0,0,0,55,48.6a66.61,66.61,0,0,0,6.82-15.27,105.84,105.84,0,0,0,3.51-14.57l.36,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.68,18.76a50.9,50.9,0,0,1-5.94,30.41A50.25,50.25,0,0,1,43.33,65.89a49.65,49.65,0,0,1-6.89,3.71l-.11-.25a59.09,59.09,0,0,0,6.52-4.17c13.59-9.89,20.56-21.92,22.27-38.66a58.64,58.64,0,0,0,.3-7.73l.26,0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.62,18.75a40.4,40.4,0,0,1,0,24.33A38.64,38.64,0,0,1,51.28,62.84,39.86,39.86,0,0,1,36.4,69.55l0-.15a42.72,42.72,0,0,0,7.41-3.2A41.83,41.83,0,0,0,66.44,26.82a43.28,43.28,0,0,0-1-8l.14-.05Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.55,18.78C75,36.17,67,58.71,49,66.62a32.33,32.33,0,0,1-12.57,2.85,36.16,36.16,0,0,0,8.23-2.15C64.12,60,73.3,38,65.55,18.78Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-13",
    points: "63.96 16.02 34.8 32.84 5.57 16.02"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.06,16.22c-9,4.53-18,9.2-27.29,13.29-.47.19-.94.39-1.44.55a1.3,1.3,0,0,1-.87.05,31,31,0,0,1-3.55-1.44c-8.58-3.93-17-8.21-25.44-12.45l.2-.39c9,4.5,18,9.14,27.29,13.21a15.75,15.75,0,0,0,1.62.6.74.74,0,0,0,.39,0,73.82,73.82,0,0,0,7.13-3.1c7.31-3.47,14.54-7.09,21.76-10.74l.2.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.06,16.25c-7.19,3.07-14.39,6.1-21.72,8.83-1.22.45-2.45.89-3.7,1.3a16.34,16.34,0,0,1-3.87.94,38.34,38.34,0,0,1-7.57-2.26c-2.45-.9-4.87-1.85-7.29-2.81q-7.26-2.91-14.44-6l.2-.46c7.19,3,14.41,6,21.73,8.73a40.19,40.19,0,0,0,7.37,2.19c2.51-.29,5-1.37,7.37-2.17,7.32-2.7,14.54-5.7,21.72-8.75l.2.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64.05,16.27c-7.79,2.66-15.61,5.24-23.6,7.23a30.55,30.55,0,0,1-5.68,1,32,32,0,0,1-5.68-1c-5.54-1.37-11-3.08-16.41-4.81q-3.6-1.17-7.2-2.4l.17-.51C13.76,18.38,21.88,21,30.17,23a28.94,28.94,0,0,0,4.6.72,20.93,20.93,0,0,0,3.67-.52c3.7-.77,7.34-1.84,11-2.9q7.26-2.17,14.47-4.55l.17.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64,16.29C56.8,18,49.55,19.66,42.21,20.84a56.74,56.74,0,0,1-7.44.79,56.4,56.4,0,0,1-7.44-.8C22.43,20.05,17.58,19,12.74,18c-2.42-.54-4.83-1.11-7.23-1.69l.12-.53q3.61.8,7.26,1.54c4.83,1,9.69,1.94,14.57,2.71a57.89,57.89,0,0,0,7.31.77,48.28,48.28,0,0,0,5.48-.49c5.49-.79,11-1.87,16.4-3q3.63-.74,7.25-1.55l.12.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64,16.29a288.78,288.78,0,0,1-29.23,2.5c-9.79-.2-19.51-1.33-29.22-2.5l.06-.53c2.43.23,4.86.44,7.29.65,9.7.78,19.43,1.87,29.16,1.13,4.87-.3,9.73-.7,14.59-1.13,2.43-.21,4.86-.42,7.29-.66l.06.54Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64,16.27c-9.47-.07-19.76-.33-29.19-.33s-19.73.27-29.18.33l0-.5a476.35,476.35,0,0,1,51.12-.37c2.43.12,4.86.22,7.29.37l0,.5Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.91,16.24c-9.63-1.6-19.36-3.07-29.14-3.14a157.61,157.61,0,0,0-21.89,2c-2.43.34-4.85.74-7.27,1.15l-.09-.43c2.39-.59,4.81-1.06,7.22-1.53a130.28,130.28,0,0,1,22-2.41,129.13,129.13,0,0,1,22,2.4c2.42.47,4.83,1,7.22,1.53l-.1.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.89,16.19c-9.32-3.37-19.19-5.83-29.12-5.94a82.06,82.06,0,0,0-22,3.62c-2.4.68-4.77,1.47-7.12,2.32l-.14-.34a83.08,83.08,0,0,1,14.25-4.93A68.44,68.44,0,0,1,31.91,9,60.81,60.81,0,0,1,49.78,10.9,80.49,80.49,0,0,1,64,15.85l-.15.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.88,16.13C55.12,10.87,45,7.49,34.77,7.4A56,56,0,0,0,12.5,12.58a57.7,57.7,0,0,0-6.85,3.55l-.16-.22C18.16,6.62,35.28,3.06,50.22,8.68A51.49,51.49,0,0,1,64,15.91l-.16.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M63.91,16.07C49.26,2.94,28.85.71,12.1,11.27a44,44,0,0,0-6.48,4.8L5.51,16a40,40,0,0,1,13.23-9.5A39,39,0,0,1,54.48,8.31,37.79,37.79,0,0,1,64,16l-.11.1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M64,16A36.85,36.85,0,0,0,18.63,5.46,39.1,39.1,0,0,0,5.57,16a33,33,0,0,1,8.78-9.41C30.12-5,53.75-.92,64,16Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultLogo);
export default __webpack_public_path__ + "static/media/defaultLogo.3d5ce3a39ce585466dd2d8f31b797815.svg";
export { ForwardRef as ReactComponent };